import React from 'react';

const SwitchArrowsSVG = ({
  className = '',
  color = '#8940FA',
  width = 22,
  height = 25,
}) => (
  <svg width={width} height={height} viewBox="0 0 20 20" className={className}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(2.000000, 2.000000)"
        fill={color}
        fillRule="nonzero"
      >
        <path d="M1.06666667,4.8 L10.6666667,4.8 L10.6666667,6.4 C10.6666667,6.9712 11.1184,7.46666667 11.7333333,7.46666667 C12.1333333,7.46666667 12.3914667,7.25813333 12.8,6.93333333 L15.3664,4.8 C15.7498667,4.4752 16,4.16693333 16,3.73333333 C16,3.29973333 15.7498667,2.99146667 15.3664,2.66666667 L12.8,0.533333333 C12.3914667,0.208533333 12.1333333,0 11.7333333,0 C11.1184,0 10.6666667,0.495466667 10.6666667,1.06666667 L10.6666667,2.66666667 L1.06666667,2.66666667 C0.477333333,2.66666667 0,3.144 0,3.73333333 C0,4.32266667 0.477333333,4.8 1.06666667,4.8 Z M14.9333333,11.2 L5.33333333,11.2 L5.33333333,9.6 C5.33333333,9.0288 4.8816,8.53333333 4.26666667,8.53333333 C3.86666667,8.53333333 3.60853333,8.74186667 3.2,9.06666667 L0.633066667,11.2 C0.250133333,11.5248 0,11.8336 0,12.2666667 C0,12.6997333 0.250133333,13.0085333 0.633066667,13.3333333 L3.2,15.4666667 C3.60853333,15.7914667 3.86666667,16 4.26666667,16 C4.8816,16 5.33333333,15.5045333 5.33333333,14.9333333 L5.33333333,13.3333333 L14.9333333,13.3333333 C15.5226667,13.3333333 16,12.856 16,12.2666667 C16,11.6773333 15.5226667,11.2 14.9333333,11.2 Z" />
      </g>
    </g>
  </svg>
);

export default SwitchArrowsSVG;
